'user strict'
const ex = require('../lib/error');
const campaigns = require('../models').campaigns
const campaignTypes = require('../models').campaignTypes
const BASE_URL = "https://play.google.com/store/apps/details?id=com.billbook.app&referrer=cid=";

const createCampaign = (req, res, next) => {
    req.body.campaignUrl = BASE_URL + req.body.campaignId;
    campaigns
        .create(req.body)
        .then(campaign => {
            req.responseObject.data = campaign;
            next();
        })
        .catch(error => {
            if(error.name === 'SequelizeUniqueConstraintError') {
                ex.raiseError(req, res, error.name, 400, error);
            } else {
                ex.raiseError(req, res, error.name, 500, error);
            }
        })
}

const createCampaignType = (req, res, next) => {
    
    // if there is admin ID then created_by_id = adminId
    // (needs to be implemented when admin auth available)
    
    campaignTypes
        .create(req.body)
        .then(campaignType => {
            req.responseObject.data = campaignType;
            next();
        })
        .catch(error => {
            if(error.name === 'SequelizeUniqueConstraintError') {
                ex.raiseError(req, res, error.name, 400, error);
            } else {
                ex.raiseError(req, res, error.name, 500, error);
            }
        })
}

const getAllCampaigns = (req, res, next) => {

    // where condition needs to rechecked after discussing use cases of is_active and is_delete
    // current use case ==>> 
    // is_active = false (campain not active but can be reactivated)
    // is_delete = false (campain deleted or permanently deactivated)
    let where = { is_delete: false };

    campaignTypes.hasMany(campaigns, { foreignKey: 'campaignTypeId' });
    campaigns.belongsTo(campaignTypes, { foreignKey: 'campaignTypeId' });

    campaigns
        .findAll({
            where: where,
            include: [{
                model: campaignTypes,
                where: where
            }]
        })
        .then(campaigns=> {
            req.responseObject.data = campaigns;
            next();
        })
        .catch(error => {
            ex.raiseError(req, res, error.name, 500, error);
        })
}

const getAllCampaignTypes = (req, res, next) => {

    // where condition needs to rechecked after discussing use cases of is_active and is_delete
    // current use case ==>> 
    // is_active = false (campain type not active but can be reactivated)
    // is_delete = false (campain type deleted or permanently deactivated)
    let where = { is_delete: false };

    campaignTypes
        .findAll({where: where})
        .then(campaignTypes=> {
            req.responseObject.data = campaignTypes;
            next();
        })
        .catch(error => {
            ex.raiseError(req, res, error.name, 500, error);
        })
}

const updateCampaign = (req, res, next) => {
    campaigns
        .update(req.body, {
            where: { campaignId: req.params.campaignId }
        })
        .then(result => {
            // result only contains no. of affected rows and not the updated data
            next();
        })
        .catch(error => {
            if(error.name === 'SequelizeUniqueConstraintError') {
                ex.raiseError(req, res, error.name, 400, error);
            } else {
                ex.raiseError(req, res, error.name, 500, error);
            }
        })
}

const updateCampaignType = (req, res, next) => {
    campaignTypes
        .update(req.body, {
            where: { campaignTypeId: req.params.campaignTypeId }
        })
        .then(result => {
            // result only contains no. of affected rows and not the updated data
            next();
        })
        .catch(error => {
            if(error.name === 'SequelizeUniqueConstraintError') {
                ex.raiseError(req, res, error.name, 400, error);
            } else {
                ex.raiseError(req, res, error.name, 500, error);
            }
        })
}

const fetchCid = (data, separator) => {
    // referrer_link format must be "cid=xyz,otherArg=abc,..."
    // format checked in Joi validator (MAU015)
    let referrer_link = data.referrer_link.split(separator);
    let cid = null;
    for(let i=0; i<referrer_link.length; i++) {
      if(referrer_link[i].substring(0, 4) === "cid=") {
        cid = referrer_link[i].substring(4);
        break;
      }
    }
  
    if(!cid) {
      return null;
    }
    return cid;
}

const getCampaignById = (req, res, next) => {
    
    if(req.params.hasOwnProperty('referrer_link')) {

        const campaignId = fetchCid(req.params, ',');
        if(campaignId) {
            campaigns
                .findOne({ 
                    where: { 
                        campaignId,
                        is_active: true
                    }
                })
                .then(campaign => {
                    if(!campaign) {
                        ex.raiseError(req, res, "Campaign Not Found", 400, "Campaign Not Found");
                    } else {
                        req.params.campaignRefId = campaign.refId;
                        req.responseObject.campaignCount = campaign.campaignCount;
                        delete req.params['referrer_link']; // delete referrer_link after extracting cid
                        next();
                    }
                })
                .catch(error => {
                        ex.raiseError(req, res, error.name, 500, error);
                })
        } else {
            next();
        }
    } else {
        next();
    }
}

const increaseCampaignCount = (req, res, next) => {
    if(req.responseObject.hasOwnProperty("campaignCount")) {
        campaigns
            .update({campaignCount: req.responseObject.campaignCount+1}, {
                where: {refId: req.params.campaignRefId}
            })
            .then(result => {
                next();
            })
            .catch(error => {
                ex.raiseError(req, res, error.name, 500, error);
            })
    } else {
        next();
    }
}

const getCampaignTypeById = (req, res, next) => {
    
    const campaignTypeId = req.params.campaignTypeId || req.body.campaignTypeId;

    campaignTypes
        .findOne({ 
            where: { campaignTypeId }
        })
        .then(campaignType => {
            if(!campaignType) {
                ex.raiseError(req, res, "Campaign Type Not Found", 400, "Campaign Type Not Found");
            } else {
                if(req.params.campaignTypeId) {
                    req.responseObject.data = campaignType;
                }
                next();
            }
        })
        .catch(error => {
                ex.raiseError(req, res, error.name, 500, error);
        })
}

module.exports = {
    createCampaign,
    createCampaignType,
    getAllCampaigns,
    getAllCampaignTypes,
    updateCampaign,
    updateCampaignType,
    getCampaignById,
    getCampaignTypeById,
    increaseCampaignCount
}